import * as Yup from 'yup'

export default Yup.object().shape({
  Email: Yup.string()
    .email('Please enter a valid email address')
    .required('Please enter a valid email address')
})
